﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/appDownload`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'getAppDownloadList' },
  { name: 'dropDownRangeSelect' },
  { name: 'getImageRightFileForDownload' },
  { name: 'getMultipleImageRightFilesForDownload' },
]);

const GetAppDownloadList = (body) => api.endpoints.getAppDownloadList.post(body);
const DropDownForDateRange = () => api.endpoints.dropDownRangeSelect.post();
const GetSingleFileDownload = (body) => api.endpoints.getImageRightFileForDownload.post(body);
const GetMultiFileDownload = (body) =>
  api.endpoints.getMultipleImageRightFilesForDownload.post(body);

export { GetAppDownloadList, DropDownForDateRange, GetSingleFileDownload, GetMultiFileDownload };
